import { render, staticRenderFns } from "./TypeContract.vue?vue&type=template&id=6145f474"
import script from "./TypeContract.vue?vue&type=script&lang=js"
export * from "./TypeContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports